import { on } from '@ember/modifier';
import type { TOC } from '@ember/component/template-only';

export interface TioQuicklinkButtonSignature {
  Args: {
    buttonText: string;
    isDisabled?: boolean;
    method: () => void;
  };
  Element: HTMLButtonElement;
}

const TioQuicklinkButton: TOC<TioQuicklinkButtonSignature> = <template>
  <button
    type="button"
    {{on "click" @method}}
    disabled={{@isDisabled}}
    class="text-lg tio-bg-surface h-10 text-md tio-fg-secondary disabled:tio-fg-disabled align-right p-2 w-full
      {{unless @isDisabled 'hover:tio-bg-sunken hover:cursor-pointer hover:p-full'}}
      "
  >
    {{@buttonText}}
  </button>
</template>;

export default TioQuicklinkButton;
